<script lang="ts">
  import { createEventDispatcher } from "svelte";
  export let vocabData;
  let vocabulary = vocabData.halloween;
  // $: console.log(vocabulary);

  const dispatch = createEventDispatcher();

  //let vocabulary = vocabData.halloween;
</script>

<style>
  header {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  h2 {
    width: 100%;
    text-align: center;
  }

  .fa-times-circle {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 1.8rem;
    cursor: pointer;
  }

  .fa-volume-cont {
    font-size: 1.5rem;
    margin-left: 6%;
    cursor: pointer;
  }

  ul {
    width: 100%;
    padding: 0;
    margin: 0 0 0 25%;
    text-align: left;
    height: 70vh;
    overflow: scroll;
  }

  li {
    display: flex;
    justify-content: flex-start;
    line-height: 150%;
    align-items: center;
    font-size: 2rem;
    font-weight: 400;
  }

  img {
    width: 70px;
    margin-right: 10px;
  }
</style>

<header>
  <h2>Vocabulary Practice</h2>
  <i class="far fa-times-circle" on:click />
</header>
<ul id="list-cont">
  {#each vocabulary as { content, matchid }}
    {#if content.includes('http')}
      <li>
        <img src={content} alt={matchid} />
        <span>{matchid}</span>
        <span class="fa-volume-cont"><i
            class="fas fa-volume-up"
            id={matchid}
            on:click={(e) => dispatch('playaudio', e)} /></span>
      </li>
    {/if}
  {/each}
</ul>
